<span class="rights">{{rights}}</span>
